import { exportType } from '../../../../AudienceForm/constants.ts';
import { DEFAULT_PROVIDER_ID } from '../../../../hooks/useProviders.ts';
import { ReportStatusValues } from '../context/audienceInsights.ts';

const SUPPORTED_REPORT_STATUSES: ReportStatusValues[] = [
  ReportStatusValues.COMPLETE,
  ReportStatusValues.SF_COMPLETE,
  ReportStatusValues.SF_PROCESSING,
];

const CUSTOM_EXPORT_TYPES: string[] = [exportType.BIDSTREAM, exportType.BIDSTREAM_PLUS];

const BIDSTREAM_PLUS_SUPPORTED_PROVIDERS = ['merkle', 'choreograph', 'epsilon', 'analyticsiq'] as const;

export function isInsightRequestSupported(
  audienceExportType: string | undefined,
  reportStatus: string | undefined | null,
  directAudienceProvider: string | undefined | null
): boolean {
  if (!reportStatus || !SUPPORTED_REPORT_STATUSES.includes(reportStatus as ReportStatusValues)) {
    return false;
  }

  if (!audienceExportType || !CUSTOM_EXPORT_TYPES.includes(audienceExportType)) {
    return true;
  }

  if (audienceExportType === exportType.BIDSTREAM_PLUS) {
    const effectiveProvider = directAudienceProvider === DEFAULT_PROVIDER_ID ? null : directAudienceProvider;

    if (effectiveProvider && (BIDSTREAM_PLUS_SUPPORTED_PROVIDERS as readonly string[]).includes(effectiveProvider)) {
      return true;
    }
  }

  return false;
}
